module.exports = __webpack_public_path__ + "img/mc_cafe.15458654.png";